// List of SVG icon names loaded from default/static path
export const SVG_ICONS_LIST = [
  'book-another-appointment', 'qr-code', 'download-appointment', 'download', 'edit',
  'phone', 'mobile', 'envelope', 'rebook', 'appointment-cancel',
  'location', 'person_check', 'person_off', 'plus', 'add', 'check_circle', 'info', 'help', 'help_outline',
  'customer', 'sms', 'paypal', 'booking',
  'appointment', 'calendar', 'dashboard', 'integrations', 'billing',
  'setting', 'support', 'language', 'notification', 'internal-widget',
  'lock', 'analytics', 'complete_setup', 'menu',
  'arrow_circle_left', 'close', 'master_data', 'first-appointment', 'first-conference',
  'select', 'created', 'worker', 'name', 'address',
  'email', 'operation', 'first-group-appointment', 'search', 'arrow_forward',
  'integration', 'integration_guideline', 'tenant_management', 'partner_management',
  'role_permissions', 'subscriptions', 'global_notification', 'release_notes', 'role_import',
  'postcode_import', 'resource_import', 'customer_import', 'reseller', 'deal',
  'payments', 'past_invoices', 'ip_whitelisting', 'sso', '2fa',
  'audit_logs', 'resources', 'absences', 'availabilities', 'external_calendars',
  'appointment_status', 'custom_css', 'template', 'customer_types', 'widget_config',
  'stores', 'privacy', 'webhook', 'manage_api_key',
  'utilization_report', 'setup_pricing_table', 'templates', 'design_booking_page', 'whitelabel',
  'coupons', 'smart_action', 'setup_assistant', 'notification_active', 'vat',
  'help_center', 'academy_training_video', 'chat', 'system_status', 'blog',
  'service', 'advanced_settings', 'workflow', 'widget_settings', 'booking_question',
  'admin', 'security', 'profile', 'company_profile', 'email_sms_history',
  'mail', 'booking_type', 'attributes', 'dashboard_customize', 'category',
  'export_notes', 'for_you', 'highlight', 'filter', 'arrow_right',
  'group', 'star', 'hourglass', 'visibility_off', 'clock',
  'event_reschedule', 'money_bag', 'hub', 'bar_chart',
  'currency_box', 'calendar-user', 'conference', 'group-appointment', 'store',
  'first-widget-integration', 'contact_us', 'star-active', 'website', 'inquiry', 'emergency',
  'drag_indicator', 'featured_seasonal_and_gifts', 'admin', 'best_practices', 'history', 'chevron_forward', 'credit_card', 'calendar_lock','videocam'
];

// List of SVG icons with custom file paths
export const SVG_WITH_PATH_ARRAY = [
  { name: 'event_repeat', path: 'assets/images/material/event_repeat.svg' },
  { name: 'migration', path: 'assets/images/material/migration.svg' },
  { name: 'lock_open', path: 'assets/images/material/lock_open.svg' },
  { name: 'refresh', path: 'assets/images/material/refresh.svg' },
  { name: 'schedule', path: 'assets/images/material/schedule.svg' },
  { name: 'package_2', path: 'assets/images/material/package_2.svg' },
  { name: 'notifications_off', path: 'assets/images/material/notifications_off.svg' },

  // Brand-neutral icons (resolved to correct brand folder via angular.json assets config)
  { name: 'brand-logo', path: 'assets/images/brand/logo.svg' },
  { name: 'brand-logo-white', path: 'assets/images/brand/logo-white.svg' },
  { name: 'brand-logo-icon', path: 'assets/images/brand/logo-icon.svg' },
  { name: 'brand-meeting-icon', path: 'assets/images/brand/meeting-icon.svg' },
  { name: 'brand-minimal-user', path: 'assets/images/brand/minimal-user.svg' },

  // Third-party meeting provider logos (used by landing pages / appointment detail)
  { name: 'zoom', path: 'assets/images/meetings/zoom.svg' },
  { name: 'unblu', path: 'assets/images/meetings/unblu.svg' },
];

// List of SVG icons with custom file paths (shared across app)
export const SVG_ICONS = [
  { name: 'customer-deleted', path: 'assets/images/material/person_cancel.svg' },
  { name: 'cancel', path: 'assets/images/cancel.svg' },
  { name: 'cancel_appointment', path: 'assets/images/cancel_appointment.svg' },
  { name: 'dollar', path: 'assets/images/dollar.svg' },
  { name: 'open_in_new', path: 'assets/images/open_in_new.svg' },
  { name: 'description', path: 'assets/images/material/description.svg' },
  { name: 'bell', path: 'assets/images/bell.svg' },
  { name: 'person', path: 'assets/images/person.svg' },
  { name: 'mail', path: 'assets/images/material/mail.svg' },
  { name: 'link', path: 'assets/images/material/link.svg' },
  { name: 'copy', path: 'assets/images/copy.svg' },
];

// List of SVG icons with custom file paths for analytics
export const ANALYTICS_SVG_ICONS = [
  { name: 'filter', path: 'assets/images/material/filter.svg' },
  { name: 'arrow_right', path: 'assets/images/material/arrow_right.svg' },
  { name: 'group', path: 'assets/images/material/group.svg' },
  { name: 'star', path: 'assets/images/icons/star.svg' },
  { name: 'hourglass', path: 'assets/images/material/hourglass.svg' },
  { name: 'visibility_off', path: 'assets/images/material/visibility_off.svg' },
  { name: 'visibility', path: 'assets/images/material/visibility.svg' },
  { name: 'clock', path: 'assets/images/material/clock.svg' },
  { name: 'clock_outline', path: 'assets/images/material/clock_outline.svg' },
  { name: 'block', path: 'assets/images/material/block.svg' },
  { name: 'event_busy', path: 'assets/images/material/event_busy.svg' },
  { name: 'event_reschedule', path: 'assets/images/material/event_reschedule.svg' },
  { name: 'money_bag', path: 'assets/images/material/money_bag.svg' },
  { name: 'monitor', path: 'assets/images/material/monitor.svg' },
  { name: 'hub', path: 'assets/images/material/hub.svg' },
  { name: 'bar_chart', path: 'assets/images/material/bar_chart.svg' },
  { name: 'currency_box', path: 'assets/images/material/currency_box.svg' },
  { name: 'person_search', path: 'assets/images/material/person_search.svg' },
];

export const JRNI_MIGRATION_ICONS = [
  { name: 'migration-in-progress', path: 'assets/images/material/migration-in-progress.svg' },
];
